var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "nativewind/jsx-runtime";
import React from 'react';
import { Text } from 'react-native';
import { SccPressable } from '@/components/SccPressable';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
export default function PressableChip(_a) {
    var { label, active = false, disabled = false } = _a, props = __rest(_a, ["label", "active", "disabled"]);
    return (_jsx(SccPressable, Object.assign({ elementName: "pressable_chip", disableLogging: true, style: [
            {
                paddingVertical: 10,
                paddingHorizontal: 16,
                borderRadius: 48,
                borderWidth: 1,
                borderColor: '#DCDEE3',
                backgroundColor: color.white,
            },
            active && {
                borderColor: color.brand,
                backgroundColor: '#EBF5FF',
            },
            disabled && {
                borderColor: color.gray20,
                backgroundColor: color.gray10,
            },
        ], disabled: disabled }, props, { children: _jsx(Text, { style: [
                {
                    fontSize: 14,
                    lineHeight: 20,
                    fontFamily: font.pretendardRegular,
                    color: color.black,
                },
                active && {
                    color: color.brand,
                },
                disabled && {
                    color: color.gray40,
                },
            ], children: label }) })));
}
